import { render, staticRenderFns } from "./history.vue?vue&type=template&id=8b274132&scoped=true"
import script from "./history.vue?vue&type=script&lang=js"
export * from "./history.vue?vue&type=script&lang=js"
import style0 from "./history.vue?vue&type=style&index=0&id=8b274132&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b274132",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Empty: require('/drone/src/components/Empty/index.vue').default})
